// todo validate data decorator
import Vue from 'vue'
import Objects from '@/api/services/objects'
const getDefaultState = () => ({
  objects: [],
  footprint: [],
  mapFitMarker: {},
  marks: ['BMW', 'Volkswagen'],
  history: Vue.ls.get('history', [], Object),
  treeStore: []
})
export default {
  state: getDefaultState(),
  getters: {
    tree: state => state.treeStore,
    getMapFitMarker: state => state.mapFitMarker,
    treeRecycle: state => (needle, haystack, showAll) => state.treeStore.reduce((acc, curr, index) => {
      const childFlag = haystack === 'mode' ? needle > 0 && needle < 6 : needle.length > 2
      const children = childFlag ? (curr.children.filter(x => new RegExp(needle, 'i').test(x.data[haystack]))) : curr.children
      return children.length ? [...acc, {idxg: index, length: children.length, id: curr.id, collapsed: curr.collapsed, text: curr.text}, ...(curr.collapsed || showAll ? children : [])] : acc
    }, []),
    getObjects: state => state.treeStore.reduce((acc, curr) => [...acc, ...curr.children], []),
    getFootprint: state => state.footprint,
    getObjectFromTree: (state) => (needle) => {
      const obj = state.treeStore.reduce((acc, curr, groupIndex) => [...acc, ...curr.children.reduce((acc, curr, index) => acc.concat({...curr, idx: index, idxg: groupIndex}), [])], []).find(
        obj => obj.data.id === parseInt(needle) || obj.data.imei === needle
      )
      return obj ? {
        idx: obj.idx,
        idxg: obj.idxg,
        obj: obj.data
      } : {
        idx: -1,
        idxg: -1,
        obj: undefined
      }
    },
    getGroupsFromTree: (state) => state.treeStore.map((curr, index) => ({
      id: curr.data.id,
      idxg: index,
      name: curr.text
    })),
    getFootPoint: (state) => (needle) => {
      const index = state.footprint.findIndex(obj => obj.id === parseInt(needle))
      return {
        idx: index,
        obj: state.footprint[index]
      }
    },
    getHistory: (state) => state.history,
    getMarks: (state) => state.marks
  },
  mutations: {
    collapseTreeGroup (state, id) {
      state.treeStore[id].collapsed = !state.treeStore[id].collapsed
    },
    fitNewMarker (state, pos) {
      state.mapFitMarker = pos
      if (Array.isArray(state.footprint) && state.footprint.length) {
        state.footprint = []
      }
    },
    updateTreeStore (state, newTree) {
      state.treeStore = newTree
    },
    addAddress (state, data) {
      delete state.footprint[data.idx][data.param]
      state.footprint[data.idx][data.param] = data.value
    },
    changeGroup (state, data) {
      state.treeStore[data.idxg].children.unshift(...state.treeStore[data.idxg_old].children.splice(data.idx_old, 1))
    },
    updateFootprint (state, data) {
      if (!Array.isArray(data)) {
        data = [].concat(data)
      }
      state.footprint = data
    },
    appendObject (state, data) {
      const treeId = state.treeStore.findIndex(obj => obj.data.id === data.group_id)
      state.treeStore[treeId].children.push(
        {
          text: data.name,
          data: data
        }
      )
    },
    addToHistory (state, data) {
      if (!Array.isArray(state.history)) {
        state.history = []
      }
      if (!state.history.some(el => el.id === data.id)) {
        state.history.unshift({
          id: data.id,
          group_id: data.group_id,
          date: new Date()
        })
        if (state.history.length > 8) {
          state.history.splice(-1, 1)
        }
        Vue.ls.set('history', state.history)
      }
    },
    resetObjectsState (state) {
      Object.assign(state, getDefaultState())
    },
    modifyTreeObject (state, data) {
      state.treeStore[data.idxg].children[data.idx].data[data.param] = data.value
      if (data.param === 'name') {
        state.treeStore[data.idxg].children[data.idx].text = data.value
      }
    },
    deleteFromTree (state, data) {
      state.treeStore[data.idxg].children.splice(data.idx, 1)
      delete state.footprint
      state.footprint = []
      if (Array.isArray(state.history) && state.history.length) {
        const idx = state.history.findIndex(obj => obj.id === parseInt(data.id))
        if (idx >= 0) {
          state.history.splice(idx, 1)
          state.history.sort()
          Vue.ls.set('history', state.history)
        }
      }
    }
  },
  actions: {
    updateTree ({commit}, tree) {
      commit('updateTreeStore', tree)
    },
    getObjects ({commit}) {
      return new Promise(resolve => {
        Objects.getObjects().then(data => {
          commit('updateTreeStore', data)
          resolve(data)
        })
      })
    },
    getObjectHistory ({commit}, config) {
      return new Promise(resolve => {
        Objects.getObjectHistory(config).then(data => {
          console.log(data)
          commit('updateFootprint', data)
          resolve(data)
        })
      })
    },
    getAddress ({commit, state}, obj) {
      if (!state.footprint[obj.idx].address) {
        return new Promise(resolve => {
          Objects.getObjectAddress(obj.obj).then(data => {
            commit('addAddress', {idx: obj.idx, value: data.data, param: 'address'})
            resolve(data)
          })
        })
      }
    },
    getObjectCurrentAddress ({commit, state}, obj) {
      if (!state.treeStore[obj.idxg].children[obj.idx].data.address &&
        !!obj.obj.lat && !!obj.obj.lng) {
        return new Promise(resolve => {
          Objects.getObjectAddress(obj.obj).then(data => {
            commit('modifyTreeObject', {idx: obj.idx, idxg: obj.idxg, value: data.data, param: 'address'})
            resolve(data)
          })
        })
      }
    },
    updateObject ({commit}, data) {
      commit('modifyTreeObject', data)
    },
    changeGroup ({commit, dispatch, state}, data) {
      // console.log(data)
      const dData = (value, param) => ({
        idx: data.idx_old,
        idxg: data.idxg_old,
        value: value,
        param: param
      })
      // console.log(dData(data.id, 'group_id'))
      return new Promise((resolve, reject) => {
        Objects.setSingleObjectGroup({
          id: data.id,
          obj_id: state.treeStore[data.idxg_old].children[data.idx_old].id
        }).then((status) => {
          if (status) {
            dispatch('updateObject', dData(data.id, 'group_id'))
            resolve(dData(data.name, 'group'))
          } else {
            reject(status)
          }
        })
      }).then(data => {
        dispatch('updateObject', data)
      }).then(() => {
        commit('changeGroup', data)
      }).catch(status => {
        console.log('setGroupStatus = ' + status)
      })
    },
    deleteObject ({commit}, data) {
      commit('deleteFromTree', data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/objects.js